// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityApplicationWorkflows = {
  actions: {
    applicationGrantRules: "Access Rules",
    roleMappings: "Role Mappings",
    credentials: "Credentials",
    roleCatalogs: "Role Catalogs",
    syncRoleCatalog: "Sync Role Catalogs",
    memberSnapshots: "Member Snapshots",
    syncMemberSnapshots: "Sync Member Snapshots",
    syncSourceRequired:
      "Configure the sync API URL in application metadata_json.platform_sync_base_url first",
    applicationContext: "Application Context",
    createGrant: "Create Access Rule",
    createRoleMapping: "Create Application Role Mapping",
    rotateCredential: "Rotate Access Credentials",
    enableApplication: "Enable Application",
    disableApplication: "Disable Application",
  },
  drawers: {
    applicationGrant: "Application Access Rules · {name}",
    applicationGrantShort: "Application Access Rules",
    applicationRoleMapping: "Application Role Mappings · {name}",
    applicationRoleMappingShort: "Application Role Mappings",
    credentials: "Application Access Credentials · {name}",
    credentialsShort: "Application Access Credentials",
    roleCatalogs: "Role Catalogs · {name}",
    roleCatalogsShort: "Role Catalogs",
    memberSnapshots: "Member Snapshots · {name}",
    memberSnapshotsShort: "Member Snapshots",
    applicationContext: "Application Context · {name}",
    applicationContextShort: "Application Context",
  },
  alerts: {
    credentialIssued:
      "A new Client Secret has been generated and is shown only once. Save it to the application configuration now.",
    applicationEntryUnitsHint:
      "The `exam` record still represents one business product, but it should be understood as two access entries: `exam-admin` and `exam-candidate`.",
  },
  confirms: {
    removeApplicationGrantTitle: "Remove Access Rule",
    removeApplicationGrantDescription: "Remove the {access} rule for {subject}?",
    updateApplicationStatusTitle: "Update Application Status",
    updateApplicationStatusDescription: "Update {application} to {status}?",
    removeRoleMappingTitle: "Remove Application Role Mapping",
    removeRoleMappingDescription: "Remove {from} -> {to}?",
  },
  messages: {
    applicationGrantRemoved: "Application access rule removed",
    applicationGrantRemoveFailed: "Failed to remove application access rule",
    roleMappingRemoved: "Application role mapping removed",
    roleMappingRemoveFailed: "Failed to remove application role mapping",
    credentialActivated: "Credential activated",
    credentialActivateFailed: "Failed to activate credential",
    credentialDeactivated: "Credential deactivated",
    credentialDeactivateFailed: "Failed to deactivate credential",
    applicationUpdated: "Application updated",
    applicationCreated: "Application created",
    applicationUpdateFailed: "Failed to update application",
    applicationCreateFailed: "Failed to create application",
    noTargetApplication: "No target application selected",
    applicationGrantCreated: "Application access rule created",
    applicationGrantCreateFailed: "Failed to create application access rule",
    roleMappingUpdated: "Application role mapping updated",
    roleMappingCreated: "Application role mapping created",
    roleMappingUpdateFailed: "Failed to update application role mapping",
    roleMappingCreateFailed: "Failed to create application role mapping",
    credentialRotated: "Application credential rotated",
    credentialRotateFailed: "Failed to rotate application credential",
  },
  forms: {
    applicationGrantCreate: "Create Access Rule",
    applicationGrantCreateNamed: "Create Access Rule · {name}",
    roleMappingCreate: "Create Role Mapping",
    roleMappingEdit: "Edit Role Mapping · {name}",
    roleMappingShort: "Role Mapping",
    applicationOwner: "Application",
    applicationDisplayName: "Display Name",
    portalDescription: "Portal Description",
    portalGroup: "Portal Group",
    applicationName: "Internal Name",
    appKey: "Linked Service Code",
    baseUrl: "Registry-Derived Entry URL",
    redirectUris: "OIDC Redirect URIs",
    claimScopes: "OIDC Scopes",
    tokenEndpointAuthMethod: "OIDC Client Auth Method",
    sortOrder: "Sort Order",
    applicationDisplayNameHelp:
      "Used mainly for page display and selectors. This is a relatively safe copy field.",
    portalDescriptionHelp:
      "Used as the portal navigation card description. If empty, the portal keeps the default fallback copy.",
    portalGroupHelp:
      "Determines whether the portal entry appears under Common Entries or More Tools.",
    applicationNameHelp:
      "Internal identifier text. Keep it aligned with the current app meaning and avoid unrelated changes.",
    applicationNameLockedHelp:
      "Internal Name is mainly kept for system-internal and compatibility use. It should stay read-only for live apps.",
    appKeyHelp:
      "Use the service_code from the service endpoint registry so the auth configuration links back to the unique service identity. Do not use it as a new endpoint fact source.",
    appKeyLockedHelp:
      "The linked service code is the stable registry link for this access application. Changing it on a live app may break login integration, role mapping, and permission reads.",
    baseUrlHelp:
      "Displays the registry-derived application entry URL only. Standard domain, port, and path values must be maintained in the service endpoint registry, not redefined in Identity.",
    redirectUrisHelp:
      'One full callback URI per line. If empty, defaults to "registry-derived entry URL + /c/oidc/callback".',
    claimScopesHelp: "One scope per line. If empty, defaults to openid only.",
    tokenEndpointAuthMethodHelp:
      "Use none for public clients; use client_secret_post or client_secret_basic for confidential clients.",
    sortOrderHelp: "Controls the portal entry order. Smaller numbers appear first.",
    applicationStatusHelp:
      "Disabling it affects application governance and availability status. Do not treat it as a normal copy field.",
    tokenEndpointAuthMethodNone: "none (public client)",
    tokenEndpointAuthMethodClientSecretPost: "client_secret_post",
    tokenEndpointAuthMethodClientSecretBasic: "client_secret_basic",
    grantSubject: "Access Subject",
    grantObjectValue: "Subject Value",
    accessLevel: "Access Level",
    subjectType: "Subject Type",
    subjectValue: "Subject Value",
    targetBusinessRole: "Target Business Role",
    businessRoleAppOption: "Application Business Role",
    accessOption: "Can Enter",
    manageOption: "Can Manage",
    requiredApplicationDisplayName: "Please enter display name",
    requiredApplicationName: "Please enter internal name",
    requiredAppKey: "Please enter linked service code",
    requiredGrantSubject: "Please select grant subject",
    requiredObjectValue: "Please select object value",
    requiredAccessLevel: "Please select access level",
    requiredSubjectType: "Please select subject type",
    selectApplicationOwner: "Select Application",
    applicationOwnerEmpty: "No application selected",
    applicationOwnerPickerTitle: "Select Permission Binding Application",
    applicationOwnerPickerEmpty: "No identity applications available",
    applicationPickerTitle: "Select Identity Application",
    permissionApplicationSnapshotMissing:
      "IdentityPermissionDefinitionRead is missing the application_name/application_display_name snapshot",
    requiredTargetBusinessRole: "Please enter target business role",
    requiredApplicationOwner: "Please select application",
  },
} as const;

export const platformAdminIdentityWorkflows = {
  actions: {
    refresh: "Refresh",
    edit: "Edit",
    remove: "Remove",
    archive: "Archive",
    customFields: "Custom Fields",
    permissionBindings: "Permission Bindings",
    createTenant: "Create Tenant",
    createOrganization: "Create Organization",
    createRole: "Create Platform Role",
    createPermission: "Create Permission",
    createBinding: "Create Permission Binding",
    viewRawJson: "Raw JSON",
    viewAuditDetail: "Audit Detail",
    ...platformAdminIdentityApplicationWorkflows.actions,
  },
  drawers: {
    permissionBinding: "Permission Bindings · {name}",
    permissionBindingShort: "Permission Bindings",
    eventRaw: "Event #{id}",
    eventRawShort: "Raw Event",
    eventAudit: "Audit Event #{id}",
    eventAuditShort: "Audit Event",
    ...platformAdminIdentityApplicationWorkflows.drawers,
  },
  confirms: {
    removePermissionBindingTitle: "Remove Permission Binding",
    removePermissionBindingDescription: "Remove {type}:{value}?",
    ...platformAdminIdentityApplicationWorkflows.confirms,
  },
  messages: {
    permissionBindingRemoved: "Permission binding removed",
    permissionBindingRemoveFailed: "Failed to remove permission binding",
    tenantUpdated: "Tenant updated",
    tenantCreated: "Tenant created",
    tenantUpdateFailed: "Failed to update tenant",
    tenantCreateFailed: "Failed to create tenant",
    organizationUpdated: "Organization updated",
    organizationCreated: "Organization created",
    organizationUpdateFailed: "Failed to update organization",
    organizationCreateFailed: "Failed to create organization",
    roleUpdated: "Platform role updated",
    roleCreated: "Platform role created",
    roleUpdateFailed: "Failed to update platform role",
    roleCreateFailed: "Failed to create platform role",
    permissionUpdated: "Permission updated",
    permissionCreated: "Permission created",
    permissionUpdateFailed: "Failed to update permission",
    permissionCreateFailed: "Failed to create permission",
    noTargetPermission: "No target permission selected",
    permissionBindingCreated: "Permission binding created",
    permissionBindingCreateFailed: "Failed to create permission binding",
    ...platformAdminIdentityApplicationWorkflows.messages,
  },
  forms: {
    permissionCreate: "Create Permission",
    permissionEdit: "Edit Permission · {name}",
    roleCreate: "Create Platform Role",
    roleEdit: "Edit Platform Role · {name}",
    tenantCreate: "Create Tenant",
    tenantEdit: "Edit Tenant · {name}",
    organizationCreate: "Create Organization",
    organizationEdit: "Edit Organization · {name}",
    permissionBindingCreate: "Create Permission Binding",
    permissionBindingCreateNamed: "Create Permission Binding · {name}",
    tenantScope: "Tenant Scope",
    organizationScope: "Organization Scope",
    permissionKey: "Permission Key",
    resourceKey: "Resource Key",
    actionKey: "Action Key",
    roleKey: "Role Key",
    tenantName: "Tenant Name",
    organizationName: "Organization Name",
    bindingSubject: "Binding Subject",
    platformRoleOption: "Platform Role",
    userOption: "Specific User",
    businessRoleOption: "Base Identity Type",
    tenantOption: "Tenant",
    organizationOption: "Organization",
    optionalUnboundTenant: "Optional; leave empty to avoid binding to a tenant",
    optional: "Optional",
    requiredPermissionKey: "Please enter permission key",
    requiredDisplayName: "Please enter display name",
    requiredStatus: "Please select status",
    requiredRoleKey: "Please enter role key",
    requiredTenantName: "Please enter tenant name",
    requiredTenantKey: "Please enter tenant key",
    requiredOrganizationName: "Please enter organization name",
    requiredOrganizationKey: "Please enter organization key",
    requiredPlatformRole: "Please select platform role",
    requiredBusinessRoleValue: "Please enter base identity type value",
    requiredPriority: "Please enter priority",
    requiredBindingSubject: "Please select binding subject",
    requiredBusinessRole: "Please enter business role",
    ...platformAdminIdentityApplicationWorkflows.forms,
  },
  alerts: {
    ...platformAdminIdentityApplicationWorkflows.alerts,
  },
} as const;
